import type { Feature, FeatureModule } from '../../../types';
import { featureList } from '../../helpers';
import { PAYMENTS_SETTINGS_FEATURE_GROUP } from './group';

export const PAYMENTS_SETTINGS_FEATURES = {
  READ: {
    guid: 'b1f0c3a4-5d62-4e78-9a01-3c7d5e9f0500',
    name: 'payments_settings:read',
    description: 'View the payments account details, categories and receipt email template',
    action: 'read',
    product: 'payments',
    parentGuid: PAYMENTS_SETTINGS_FEATURE_GROUP.guid,
  },
  UPDATE: {
    guid: 'b1f0c3a4-5d62-4e78-9a01-3c7d5e9f0501',
    name: 'payments_settings:update',
    description: 'Edit the payments account details, categories and receipt email template',
    action: 'update',
    product: 'payments',
    parentGuid: PAYMENTS_SETTINGS_FEATURE_GROUP.guid,
  },
} as const satisfies Record<string, Feature>;

export { PAYMENTS_SETTINGS_FEATURE_GROUP } from './group';

export const PAYMENTS_SETTINGS_MODULE: FeatureModule = {
  product: 'payments',
  groups: [PAYMENTS_SETTINGS_FEATURE_GROUP],
  features: featureList(PAYMENTS_SETTINGS_FEATURES),
};
